/**
* @description Service to store Trident data for users and organizations
* @author Brendan Magee
*/

function trident($http, $q) {
  return {
    getApps() {
      if (this.apps) {
        return $q.when(this.apps);
      }

      return $http.get('/apps')
        .then(({ data }) => {
          this.apps = data;
          return data;
        });
    }
  };
}

const serviceArray = [
  '$http',
  '$q',
  trident
];

module.exports = (ngModule) => {
  ngModule.factory('trident', serviceArray);
};
